import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";

interface MusicContext {
  isPlaying: boolean;
  togglePlaying: () => void;
  updateSource: (src: string) => void;
}

export const MusicPlayerContext = React.createContext<MusicContext>({
  isPlaying: false,
  togglePlaying: () => {},
  updateSource: () => {},
});

interface MusicContextProviderProps {
  children: React.ReactNode;
}

function MusicContextProvider({ children }: MusicContextProviderProps) {
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const [audio] = useState(
    new Audio(
      process.env.PUBLIC_URL +
        "/assets/sweetestTheme/11_how_charming_is_the_place.mp3"
    )
  );

  useEffect(() => {
    audio.addEventListener("ended", () => setIsPlaying(false));

    return () => {
      audio.removeEventListener("ended", () => setIsPlaying(false));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const togglePlaying = () => {
    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
    setIsPlaying(!isPlaying);
  };

  const updateSource = (newSource: string) => {
    if (isPlaying) {
      audio.pause();
    }
    audio.src = newSource;
    audio.play();
  };

  const value: MusicContext = {
    isPlaying,
    togglePlaying,
    updateSource,
  };

  return (
    <MusicPlayerContext.Provider value={value}>
      {children}
    </MusicPlayerContext.Provider>
  );
}

export default MusicContextProvider;
